<template>
    <div :class="{ contents: !wrapper }">
        <v-text-field
            v-if="native"
            :value="nativeValue"
            :label="label"
            :rules="rules"
            :hide-details="hideDetails"
            :error-messages="error"
            :disabled="disabled"
            outlined
            dense
            type="time"
            placeholder="--:-- --"
            :append-icon="icon"
            class="native-time-input"
            @input="onNativeInput"
            @click:append="openNativePicker"
            ref="nativeTimeInput"
        />

        <component
            v-else-if="select"
            :is="dialog.comp1"
            v-bind="{ ...dialog.props1 }"
            v-model="picker"
            ref="menu"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="getValue"
                    :label="label"
                    :prepend-inner-icon="icon"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :rules="rules"
                    outlined
                    dense
                    :hide-details="hideDetails"
                ></v-text-field>
            </template>
            <v-time-picker
                v-model="selected"
                :allowed-minutes="allowAll ? null : allowedStep"
                full-width
                ampm-in-title
                color="primary"
                format="ampm"
                class="soli-round surface"
                :min="min ?? null"
            >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    rounded
                    color="contrast"
                    @click="[(picker = false), (original = true)]"
                >
                    Cancel
                </v-btn>
                <v-btn text rounded color="primary" @click="updateTime()">
                    OK
                </v-btn></v-time-picker
            >
        </component>

        <v-time-picker
            v-if="!native && !select && !intervals"
            v-model="selected"
            color="primary"
            :allowed-minutes="allowAll ? null : allowedStep"
            full-width
            ampm-in-title
            format="ampm"
            class="soli-round custom-time surface"
            header-color="transparent"
            :min="min ?? null"
            @input="updateTime()"
        >
            <v-spacer></v-spacer>

            <v-btn
                v-if="false"
                text
                color="primary"
                class="soli-round"
                @click="updateTime()"
            >
                Continue
            </v-btn></v-time-picker
        >

        <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="list-item, list-item, list-item"
            v-if="!native && loading"
        ></v-skeleton-loader>

        <div v-if="intervals?.length && native" class="px-1 contrast--text">
            Assignment Openings:
        </div>

        <div v-if="!select" class="py-3">
            <v-btn-toggle
                v-model="selectedInterval"
                dense
                v-if="hasIntervals && !loading"
                class="w-full"
            >
                <v-row class="justify-start">
                    <v-col
                        :cols="wrap ? 'auto' : 4"
                        v-for="interval in intervals"
                        :key="interval"
                        class="!flex"
                    >
                        <v-btn
                            :ripple="false"
                            :value="interval"
                            :class="[
                                narrow ? 'narrow' : null,
                                'fixed-width rounded-pill',
                                activeInterval == interval
                                    ? 'active-btn shadow-blue'
                                    : null,
                            ]"
                            outlined
                            color="contrast"
                            class="font-weight-bold"
                            @mousedown="activeInterval = interval"
                            @touchstart="activeInterval = interval"
                            @click="
                                $emit('input', interval), $emit('selectTime')
                            "
                            ><div
                                :class="
                                    activeInterval == interval
                                        ? 'active-text'
                                        : null
                                "
                            >
                                {{ interval }}
                            </div></v-btn
                        ></v-col
                    >
                </v-row>
            </v-btn-toggle>
            <v-col v-if="!hasIntervals && !loading && intervals" class="py-0">
                Sorry, no times are available for this selection
            </v-col>
        </div>
    </div>
</template>

<script>
import { VMenu, VBottomSheet } from "vuetify/lib";

export default {
    name: "SoliTime",
    components: {
        VMenu,
        VBottomSheet,
    },
    data: function () {
        return {
            picker: null,
            selectedTime: this.value,
            selectedInterval: this.value,
            original: false,
            activeInterval: null,
            /*showMinutes: false,
            showHours: true,
            showAMPM: false,
            selectedAMPM: null,
            hours: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ],
            minutes: ["00", "15", "30", "45"],
            selectedHour: null,
            selectedMinute: null*/
        };
    },
    props: {
        label: {
            type: String,
            default: "Start Time",
        },
        value: {
            type: String,
            default: "",
        },
        error: {
            type: String,
            default: "",
        },
        rules: {
            type: Array,
            default: () => [],
        },
        icon: {
            type: String,
            default: "access_time",
        },
        intervals: {
            type: Array,
            default: null,
        },
        more: {
            type: Boolean,
            default: false,
        },
        narrow: {
            type: Boolean,
            default: false,
        },
        select: {
            type: Boolean,
            default: true,
        },
        singleLesson: {
            type: Boolean,
            default: false,
        },
        isEndTime: {
            type: Boolean,
            default: false,
        },
        startTime: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        allowAll: {
            type: Boolean,
            default: false,
        },
        min: {
            type: String,
            default: null,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        native: {
            type: Boolean,
            default: false,
        },
        wrap: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        wrapper: {
            type: Boolean,
            default: true,
            description:
                "True if the component needs to inherit styles from the parent",
        },
    },
    methods: {
        allowedStep: (m) => m % 15 === 0,
        formatTime(time) {
            /*let formatted = new Date(
                `01 January 2000 ${time}`
            ).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit"
            });*/
            let formatted = moment(new Date(`01 January 2000 ${time}`)).format(
                "h:mm A"
            );
            return formatted;
        },
        onNativeInput(val) {
            if (!val) return;
            const formatted = moment(new Date(`01 January 2000 ${val}`)).format(
                "h:mm A"
            );
            this.$emit("input", formatted);
            this.$emit("selectTime");
        },
        openNativePicker() {
            const input =
                this.$refs.nativeTimeInput?.$el?.querySelector(
                    'input[type="time"]'
                );
            if (!input) return;
            if (typeof input.showPicker === "function") {
                input.showPicker();
            } else {
                input.focus();
                input.click();
            }
        },
        updateTime() {
            this.picker = false;
            this.original = false;
            this.selectedTime = this.value;
            this.$emit("selectTime");
        },
        /*getSelectValue() {
            let hour =
                this.selectedAMPM == "pm"
                    ? [
                          Number(this.selectedHour) + 12,
                          console.log(Number(this.selectedHour) + 12)
                      ]
                    : Number(this.selectedHour);
            let time = moment()
                .set({
                    hour: hour,
                    minute: Number(this.selectedMinute)
                })
                .format("lll");
            console.log(time);
            this.$emit("confirmTime", time);
        }*/
    },
    computed: {
        selected: {
            get() {
                return this.value
                    ? new Date(`01 January 2000 ${this.value}`)
                    : null;
            },
            set(value) {
                this.$emit("input", this.formatTime(value));
            },
        },
        getValue() {
            return this.original ? this.selectedTime : this.value;
        },
        dialog() {
            return {
                comp1: this.$vuetify.breakpoint.smAndDown
                    ? "v-bottom-sheet"
                    : "v-menu",
                props1: {
                    "close-on-content-click": false,
                    "nudge-right": "40",
                    "max-width": "450px",
                    "offset-y": true,
                    "min-width": "290px",
                },
            };
        },
        nativeValue() {
            if (!this.value) return "";
            const parsed = moment(new Date(`01 January 2000 ${this.value}`));
            return parsed.isValid() ? parsed.format("HH:mm") : "";
        },
        hasIntervals() {
            if (!this.intervals) return false;
            return this.intervals.length;
        },
    },
};
</script>

<style>
.narrow {
    width: 92px !important;
    padding: 0 8px;
}

.fixed-width {
    width: 106px;
}

.active-btn {
    background: #2aabe6;

    transition: background 0.3s ease-out;
}

.active-text {
    color: white;
}

.custom-time {
    border: none;
}

.custom-time .v-time-picker-title {
    color: slategrey;
}

.custom-time .v-picker__title {
    padding-bottom: 12px;
}

.custom-time .v-picker__body {
    transform: translate(0px, -10px);
    background: transparent;
}

.custom-time .v-time-picker-title__time .v-picker__title__btn,
.custom-time .v-time-picker-title__time span {
    height: 38px;
}

.custom-time .v-time-picker-title__time > .v-picker__title__btn {
    font-size: 56px;
}

.custom-time .v-picker__title__btn + span {
    font-size: 56px;
}

.custom-time .v-time-picker-title__ampm {
    font-size: 20px;
}

.native-time-input input[type="time"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-align: left;
    position: relative;
}

/* Show placeholder text when input has no value */
.native-time-input input[type="time"]:invalid,
.native-time-input input[type="time"][value=""] {
    color: transparent;
}

.native-time-input input[type="time"]:invalid::before,
.native-time-input input[type="time"][value=""]::before {
    content: attr(placeholder);
    color: rgba(0, 0, 0, 0.38);
    position: absolute;
    left: 0;
}

.native-time-input input[type="time"]:focus,
.native-time-input input[type="time"]:not([value=""]) {
    color: inherit;
}

/* Vertically center the appended icon */
.native-time-input .v-input__append-inner {
    align-self: center;
    margin-top: 0 !important;
}

.native-time-input input[type="time"]::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
}
</style>
